function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import createSagaHelpers from '@signal/utils/createSagaHelpers';
import withStore from '../withStore';
export { SAGA_MODES } from '@signal/utils/createSagaHelpers/constants';
/**
 * Dynamically injects a saga, passes component's props as saga arguments
 *
 * @param {string} key - A key of the saga
 * @param {function} saga - A root saga that will be injected
 * @param {SAGA_MODE} [mode] - Mode with which to run the saga
 * @returns {function} - `withSaga` higher-order component
 */

export default (function (_ref) {
  var key = _ref.key,
      saga = _ref.saga,
      mode = _ref.mode;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (WrappedComponent) {
    var SagaInjector = /*#__PURE__*/function (_React$Component) {
      _inherits(SagaInjector, _React$Component);

      var _super = _createSuper(SagaInjector);

      function SagaInjector() {
        var _this;

        _classCallCheck(this, SagaInjector);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "state", {
          store: null,
          injectSaga: null,
          ejectSaga: null
        });

        return _this;
      }

      _createClass(SagaInjector, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var ejectSaga = this.state.ejectSaga;
          ejectSaga(key);
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              store = _this$props.store,
              forwardedRef = _this$props.forwardedRef,
              rest = _objectWithoutProperties(_this$props, ["store", "forwardedRef"]);

          return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
            ref: forwardedRef
          }, rest));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
          var store = nextProps.store;

          if (store !== prevState.store) {
            var _createSagaHelpers = createSagaHelpers(store),
                injectSaga = _createSagaHelpers.injectSaga,
                ejectSaga = _createSagaHelpers.ejectSaga;

            injectSaga.apply(void 0, [key, {
              saga: saga,
              mode: mode
            }].concat(args));
            return {
              store: store,
              injectSaga: injectSaga,
              ejectSaga: ejectSaga
            };
          }

          return null;
        }
      }]);

      return SagaInjector;
    }(React.Component);

    _defineProperty(SagaInjector, "WrappedComponent", WrappedComponent);

    _defineProperty(SagaInjector, "propTypes", {
      store: PropTypes.object.isRequired
    });

    var SagaInjectorWithStore = withStore(SagaInjector);

    function SagaInjectorWithRef(props, ref) {
      return /*#__PURE__*/React.createElement(SagaInjectorWithStore, Object.assign({}, props, {
        forwardedRef: ref
      }));
    }

    var ComponentToReturn = /*#__PURE__*/React.forwardRef(SagaInjectorWithRef);
    ComponentToReturn.displayName = "withSaga(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
    hoistNonReactStatics(ComponentToReturn, WrappedComponent);
    return ComponentToReturn;
  };
});